"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

exports.default = zIndex;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-beta/styles/zIndex.js
// module id = 1101
// module chunks = 0